import { FC } from 'react';
import { Select, SelectOption, SelectProps } from '@shared/shared-select';
import { cn } from '@shared/shared-utils';
import { sendFormFieldInteractionEvent } from 'libs/shared/shared-gtm-tracker/src/lib/form-tracker';
import ChevronDownIcon from '../../../../../../../../../public/svg/chevron-select-down.svg';

interface SelectItemProps
  extends Omit<SelectProps, 'className' | 'optionClassName'> {
  className?: string;
  optionClassName?: string;
  name?: string;
}

const HCP_FORM_ID = 'hcp-form';

const FormSelect: FC<SelectItemProps> = ({
  options,
  value,
  placeholder,
  disabled = false,
  className = '',
  optionClassName = '',
  onSelect,
  maxHeight = 200,
  name,
  ...props
}) => {
  const enhancedOptions: SelectOption[] = options.map(
    (option: SelectOption) => ({
      ...option,
      className: cn(
        'font-medium py-4 px-4',
        'text-contact-form-text-primary hover:bg-contact-form-primary',
        'hover:text-prp-white',
        {
          'opacity-50 cursor-not-allowed': option.disabled,
          'bg-contact-form-bg-selected opacity-100': option.value === value,
        },
        option.className,
      ),
    }),
  );

  return (
    <Select
      options={enhancedOptions}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      className={cn(
        'w-full h-full rounded-[4px]',
        'border border-sign-up-email-form-border placeholder:text-contact-form-text-primary text-contact-form-text-primary text-[20px] leading-[23px] font-bold',
        className,
      )}
      optionsListClassName={cn(
        'text-ogn-blue bg-contact-form-bg-input',
        'border-b border-gray-100 last:border-b-0 text-xl',
        optionClassName,
      )}
      selectedOptionClassName="text-ogn-dark truncate whitespace-nowrap"
      onSelect={(option) => {
        if (name && typeof document !== 'undefined') {
          const form = document.getElementById(
            HCP_FORM_ID,
          ) as HTMLFormElement | null;
          const syntheticEvent = {
            target: {
              name,
              value: option.value,
              form,
            },
          } as unknown as React.ChangeEvent<HTMLInputElement>;
          sendFormFieldInteractionEvent(syntheticEvent);
        }
        onSelect?.(option);
      }}
      maxHeight={maxHeight}
      chevronIcon={
        <ChevronDownIcon className="w-[20px] h-[14px] mr-[min(1vw,20px)]" />
      }
    />
  );
};

export { FormSelect };
export type { SelectItemProps };
